import React from "react";
import Helmet from "react-helmet";
import metadata from "../../constants/seo.json";

export default function RenderMetaTags({ pathname }) {
  const records = Array.isArray(metadata) ? metadata : [];
  const normalizedPath =
    pathname === "/" || pathname === "/home-page" ? "/" : pathname;

  const defaultMeta =
    records.find((el) => el && el.seo_slug === "/") ||
    records.find((el) => el && el.seo_slug === "/home") ||
    records.find((el) => el && el.seo_slug === "/home-page") ||
    records.find((el) => el && el.seo_slug === "/default") ||
    records[0] ||
    {};

  const match =
    records.find((el) => el && el.seo_slug === normalizedPath) || defaultMeta;

  const title =
    match.seo_title || defaultMeta.seo_title || "Sunnyside Wellness";
  const hasDescription = match.seo_description !== false;
  const description = hasDescription
    ? match.seo_description || defaultMeta.seo_description
    : null;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}
